import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import "./styles/global.css";
import "./styles/components.css";
import "./styles/shell.css";
import "./styles/console.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("No #root element — index.html and main.tsx have gone out of step.");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
